import e from "react";
import { CollapsibleContainer as l } from "./index94.mjs";
import { Extras as n } from "./index190.mjs";
import m from "./index242.mjs";
const f = ({ cartItem: r, isExpanded: t, setIsExpanded: a, isDisabled: o }) => /* @__PURE__ */ e.createElement(
  l,
  {
    expand: t,
    setExpand: a,
    title: I18n.t("booking_engine.information.add_extras"),
    isDisabled: o
  },
  /* @__PURE__ */ e.createElement("div", { className: m.extras_wrapper }, t ? /* @__PURE__ */ e.createElement(n, { cartItem: r }) : null)
);
export {
  f as CollapsedExtras
};
